const sr = {
  // ============================================================
  // COMMON — Zajednicko za citavu aplikaciju
  // ============================================================
  common: {
    loading: 'Ucitavanje...',
    error: 'Greska',
    save: 'Sacuvaj',
    cancel: 'Otkazi',
    delete: 'Obrisi',
    edit: 'Izmijeni',
    create: 'Kreiraj',
    add: 'Dodaj',
    remove: 'Ukloni',
    close: 'Zatvori',
    confirm: 'Potvrdi',
    apply: 'Primijeni',
    reset: 'Resetuj',
    search: 'Pretrazi',
    filter: 'Filtriraj',
    clear: 'Ocisti',
    back: 'Nazad',
    next: 'Dalje',
    previous: 'Prethodno',
    submit: 'Posalji',
    update: 'Azuriraj',
    refresh: 'Osvjezi',
    export: 'Izvezi',
    import: 'Uvezi',
    download: 'Preuzmi',
    upload: 'Otpremi',
    print: 'Stampaj',
    copy: 'Kopiraj',
    yes: 'Da',
    no: 'Ne',
    ok: 'OK',
    done: 'Zavrseno',
    select: 'Izaberi',
    selectAll: 'Izaberi sve',
    deselectAll: 'Ponisti izbor',
    noResults: 'Nema rezultata',
    noData: 'Nema dostupnih podataka',
    required: 'Obavezno',
    optional: 'Opciono',
    actions: 'Akcije',
    details: 'Detalji',
    overview: 'Pregled',
    summary: 'Rezime',
    total: 'Ukupno',
    all: 'Sve',
    none: 'Nista',
    name: 'Naziv',
    type: 'Tip',
    status: 'Status',
    date: 'Datum',
    time: 'Vrijeme',
    description: 'Opis',
    notes: 'Napomene',
    comments: 'Komentari',
    category: 'Kategorija',
    priority: 'Prioritet',
    nation: 'Nacija',
    country: 'Drzava',
    email: 'E-posta',
    phone: 'Telefon',
    address: 'Adresa',
    location: 'Lokacija',
    coordinates: 'Koordinate',
    latitude: 'Geografska sirina',
    longitude: 'Geografska duzina',
    from: 'Od',
    to: 'Do',
    createdAt: 'Kreirano',
    updatedAt: 'Azurirano',
    createdBy: 'Kreirao',
    modifiedBy: 'Izmijenio',
    active: 'Aktivno',
    inactive: 'Neaktivno',
    enabled: 'Omoguceno',
    disabled: 'Onemoguceno',
    showing: 'Prikazano',
    of: 'od',
    page: 'Stranica',
    perPage: 'po stranici',
    rows: 'redova',
    items: 'stavki',
    results: 'rezultata',
    sortBy: 'Sortiraj po',
    ascending: 'Rastuce',
    descending: 'Opadajuce',
    viewAll: 'Prikazi sve',
    viewDetails: 'Prikazi detalje',
    goBack: 'Vrati se',
    learnMore: 'Saznaj vise',
    seeMore: 'Vidi vise',
    showMore: 'Prikazi vise',
    showLess: 'Prikazi manje',
    expandAll: 'Prosiri sve',
    collapseAll: 'Skupi sve',
    copied: 'Kopirano!',
    saved: 'Sacuvano!',
    deleted: 'Obrisano!',
    updated: 'Azurirano!',
    created: 'Kreirano!',
    success: 'Uspjeh',
    warning: 'Upozorenje',
    info: 'Informacija',
    danger: 'Opasnost',
    unknown: 'Nepoznato',
    notAvailable: 'N/D',
    never: 'Nikada',
    today: 'Danas',
    yesterday: 'Juce',
    tomorrow: 'Sutra',
    now: 'Sada',
    ago: 'prije',
    justNow: 'upravo sada',
    minutesAgo: 'prije {{count}}m',
    hoursAgo: 'prije {{count}}h',
    daysAgo: 'prije {{count}}d',
    monthsAgo: 'prije {{count}}mj',
    id: 'ID',
    version: 'Verzija',
    language: 'Jezik',
    theme: 'Tema',
    darkMode: 'Tamni rezim',
    lightMode: 'Svijetli rezim',
    failedToLoad: 'Ucitavanje podataka nije uspjelo',
    failedToSave: 'Cuvanje nije uspjelo',
    failedToDelete: 'Brisanje nije uspjelo',
    failedToUpdate: 'Azuriranje nije uspjelo',
    confirmDelete: 'Da li ste sigurni da zelite da obrisete ovo?',
    confirmAction: 'Da li ste sigurni?',
    unsavedChanges: 'Imate nesacuvane izmjene. Da li ste sigurni da zelite da napustite stranicu?',
    pageNotFound: '404 - Stranica nije pronadjena',
    pageNotFoundDesc: 'Stranica koju trazite ne postoji.',
    backToDashboard: 'Nazad na kontrolnu tablu',
    characters: 'karaktera',
    maxCharacters: 'Maksimalno {{max}} karaktera',
    remaining: '{{count}} preostalo',
    selected: '{{count}} izabrano',
    of_total: '{{count}} od {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Zaglavlje, bocna traka, meniji
  // ============================================================
  nav: {
    dashboard: 'Kontrolna tabla',
    requests: 'Zahtjevi',
    transports: 'Transporti',
    myPatients: 'Moji pacijenti',
    statistics: 'Statistika',
    flow: 'Tok',
    resources: 'Resources',
    exercise: 'Vjezba',
    administration: 'Administracija',
    map: 'Mapa',
    info: 'Informacije',
    users: 'Korisnici',
    assets: 'Sredstva',
    hubs: 'Cvorista',
    treatmentFacilities: 'Zdravstvene ustanove',
    patientImport: 'Uvoz pacijenata',
    assetTemplates: 'Sabloni sredstava',
    dayTemplates: 'Dnevni sabloni',
    announcementTicker: 'Traka obavjestenja',
    exerciseStatistics: 'Statistika vjezbe',
    settings: 'Podesavanja',
    auditLog: 'Evidencija revizije',
    exerciseControl: 'Kontrola vjezbe',
    dataSync: 'Sinhronizacija podataka',
    documentation: 'Dokumentacija',
    support: 'Podrska',
    about: 'O sistemu',
    assetContracts: 'Asset Contracts',
    notifications: 'Obavjestenja',
    schedules: 'Rasporedi',
    capacityPlanning: 'Planiranje kapaciteta',
    transportPlanning: 'Planiranje transporta',
    transportBooking: 'Rezervacija transporta',
    flowDiagram: 'Dijagram toka',
    changePassword: 'Promjena lozinke',
    missions: 'Misije',
    startPoints: 'Polazne tacke',
    hospital: 'Bolnica',
  },

  // ============================================================
  // AUTH — Prijava, lozinka, sesija
  // ============================================================
  auth: {
    login: 'Prijava',
    logout: 'Odjava',
    logoutNow: 'Odjavi se sada',
    loggingIn: 'Prijavljivanje...',
    loginFailed: 'Prijava nije uspjela',
    email: 'E-posta',
    password: 'Lozinka',
    username: 'Korisnicko ime',
    enterEmail: 'Unesite svoju e-mail adresu',
    enterPassword: 'Unesite svoju lozinku',
    enterUsername: 'Unesite svoje korisnicko ime',
    forgotPassword: 'Zaboravljena lozinka?',
    forgotPasswordTitle: 'Zaboravljena lozinka',
    forgotPasswordDesc: 'Unesite svoje korisnicko ime i e-mail adresu. Ako se oba podudaraju, administratori ce biti obavijesteni da resetuju vasu lozinku.',
    requestPasswordReset: 'Zahtijevaj resetovanje lozinke',
    sending: 'Slanje...',
    backToLogin: 'Nazad na prijavu',
    pleaseWait: 'Molimo sacekajte prije ponovnog pokusaja.',
    requestFailed: 'Zahtjev nije uspio',
    credentialsMatch: 'Ako se podaci poklapaju, administratori su obavijesteni.',
    forAccess: 'Za pristup, molimo kontaktirajte administratora sistema.',
    changePassword: 'Promjena lozinke',
    currentPassword: 'Trenutna lozinka',
    newPassword: 'Nova lozinka',
    confirmPassword: 'Potvrdite lozinku',
    passwordChanged: 'Lozinka je uspjesno promijenjena',
    passwordMismatch: 'Lozinke se ne poklapaju',
    passwordTooShort: 'Lozinka mora imati najmanje 8 karaktera',
    changingPassword: 'Mijenjanje...',
    mustChangePassword: 'Morate promijeniti lozinku prije nastavka.',
    sessionExpiring: 'Sesija istice',
    sessionExpireText: 'Vasa sesija ce isteci za <strong>{{time}}</strong>. Molimo sacuvajte svoj rad i ponovo se prijavite da nastavite.',
    dismiss: 'Odbaci',
    switchNation: 'Promijeni naciju',
    returnTo: 'Povratak na {{nation}}',
    viewingAs: 'Gledate kao',
    loggedInAs: 'prijavljeni kao {{nation}}',
    trainingMode: 'SAMO ZA POTREBE OBUKE',
    dedication: 'Kreirano sa ljubavlju i posvecenjem profesiji',
  },

  // ============================================================
  // ROLES — Korisnicke uloge i oznake
  // ============================================================
  roles: {
    admin: 'Administrator sistema',
    excon: 'Kontrolor vjezbe',
    eu: 'EU koordinator',
    planner: 'Planer',
    hub: 'Menadzer cvorista',
    nation: 'Nacija',
    readOnly: 'Samo za citanje',
    systemAdmin: 'Administrator sistema',
    transportPlanner: 'Planer transporta',
    systemRoles: 'Sistemske uloge',
  },

  // ============================================================
  // STATUS — Statusi zahtjeva, ponuda, misija
  // ============================================================
  status: {
    draft: 'Nacrt',
    underReview: 'Na pregledu',
    published: 'Objavljeno',
    underSelection: 'U selekciji',
    accepted: 'Prihvaceno',
    planned: 'Planirano',
    inTransit: 'U tranzitu',
    completed: 'Zavrseno',
    closed: 'Zatvoreno',
    withdrawn: 'Povuceno',
    pending: 'Na cekanju',
    rejected: 'Odbijeno',
    cancelled: 'Otkazano',
    active: 'Aktivno',
    inactive: 'Neaktivno',
    review: 'Pregled',
    selection: 'Selekcija',
    transit: 'Tranzit',
  },

  // ============================================================
  // CATEGORIES — Kategorije zahtjeva
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Osoblje',
    material: 'Materijal',
    equipment: 'Oprema',
    other: 'Ostalo',
    news: 'Vijesti',
  },

  // ============================================================
  // URGENCY — Nivoi hitnosti
  // ============================================================
  urgency: {
    routine: 'Rutinski',
    priority: 'Prioritetno',
    urgent: 'Hitno',
    immediate: 'Neodlozno',
  },

  // ============================================================
  // ASSETS — Tipovi transportnih sredstava
  // ============================================================
  assetTypes: {
    train: 'Voz',
    ship: 'Brod',
    aircraft: 'Avion',
    bus: 'Autobus',
    ambulance: 'Ambulantno vozilo',
    drone: 'Dron',
    helicopter: 'Helikopter',
    ferry: 'Trajekt',
    other: 'Ostalo',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Kontrolna tabla',
    goodMorning: 'Dobro jutro',
    goodAfternoon: 'Dobar dan',
    goodEvening: 'Dobro vece',
    lastLogin: 'Posljednja prijava',
    infrastructure: 'Infrastruktura',
    transportAssets: 'Transportna sredstva',
    treatmentFacilities: 'Zdravstvene ustanove',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Statistika zahtjeva',
    viewAllRequests: 'Prikazi sve zahtjeve',
    availableAssets: 'Dostupna sredstva',
    seated: 'Sjedeci',
    lying: 'Lezeci',
    intensive: 'Intenzivna njega',
    notifications: 'Obavjestenja',
    markAllRead: 'Oznaci sve kao procitano',
    noNotifications: 'Nema obavjestenja',
    notifiedWhenActivity: 'Bicete obavijesteni kada se pojavi nova aktivnost',
    viewDetailsBtn: 'Prikazi detalje',
    nationUsers: 'Korisnici nacija',
    user: 'Korisnik',
    roles: 'Uloge',
    noUsersFound: 'Nijesu pronadjeni korisnici',
    participatingNations: 'Nacije ucesnice',
    exerciseDisclaimer: 'Ovaj sistem je namjenjen iskljucivo za vjezbu. Unosite samo simulirane podatke vjezbe. Procesi rada su prilagodjeni scenariju vjezbe i mogu se razlikovati od procedura u stvarnosti. Pravila IT bezbjednosti i zastite podataka ostaju u potpunosti primjenjiva.',
    notConfigured: 'Nije konfigurisano',
    requestCount: '{{count}} zahtjev(a)',
    clickToView: 'Kliknite za pregled',
    systemAdministration: 'Administracija sistema',
    exerciseControlTitle: 'Kontrola vjezbe',
    euCoordination: 'EU koordinacija',
    transportPlanningTitle: 'Planiranje transporta',
    hubManagement: 'Upravljanje cvoristima',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Novi zahtjev',
    myDrafts: 'Moji nacrti',
    pendingReview: 'Na cekanju za pregled',
    activeTransports: 'Aktivni transporti',
    myPatients: 'Moji pacijenti',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Zahtjevi',
    newRequest: 'Novi zahtjev',
    createRequest: 'Kreiraj zahtjev',
    editRequest: 'Izmijeni zahtjev',
    requestDetail: 'Detalji zahtjeva',
    requestId: 'ID zahtjeva',
    fromNation: 'Od nacije',
    toNation: 'Za naciju',
    requestingNation: 'Nacija koja zahtijeva',
    receivingNation: 'Nacija koja prima',
    category: 'Kategorija',
    urgency: 'Hitnost',
    status: 'Status',
    patients: 'Pacijenti',
    patientCount: 'Broj pacijenata',
    offers: 'Ponude',
    offerCount: 'Broj ponuda',
    created: 'Kreirano',
    updated: 'Azurirano',
    submittedBy: 'Podnio',
    reviewedBy: 'Pregledao',
    description: 'Opis',
    medicalDetails: 'Medicinski detalji',
    transportDetails: 'Detalji transporta',
    additionalInfo: 'Dodatne informacije',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Polazna tacka',
    arrivalPoint: 'Odredisna tacka',
    estimatedDeparture: 'Procijenjeni polazak',
    estimatedArrival: 'Procijenjeni dolazak',
    submitForReview: 'Posalji na pregled',
    publish: 'Objavi',
    startSelection: 'Zapocni selekciju',
    acceptOffer: 'Prihvati ponudu',
    markInTransit: 'Oznaci kao u tranzitu',
    markCompleted: 'Oznaci kao zavrseno',
    closeRequest: 'Zatvori zahtjev',
    withdrawRequest: 'Povuci zahtjev',
    withdraw: 'Povuci',
    revertToDraft: 'Vrati na nacrt',
    deleteRequest: 'Obrisi zahtjev',
    duplicateRequest: 'Dupliciraj zahtjev',
    createFollowUp: 'Kreiraj konsolidovani zahtjev',
    followUpRequest: 'Konsolidovani zahtjev',
    parentRequest: 'Izvorni zahtjev',
    childRequests: 'Konsolidovani zahtjevi',
    noRequests: 'Nijesu pronadjeni zahtjevi',
    noOffers: 'Nema ponuda',
    addPatient: 'Dodaj pacijenta',
    removePatient: 'Ukloni pacijenta',
    patientDetails: 'Detalji pacijenta',
    contactPerson: 'Kontakt osoba',
    contactPhone: 'Kontakt telefon',
    contactEmail: 'Kontakt e-posta',
    specialRequirements: 'Posebni zahtjevi',
    medicalEquipment: 'Medicinska oprema',
    accompaniment: 'Pratnja',
    timeline: 'Hronologija',
    history: 'Istorija',
    addComment: 'Dodaj komentar',
    writeComment: 'Napisite komentar...',
    postComment: 'Postavi komentar',
    posting: 'Postavljanje...',
    noComments: 'Nema komentara',
    coverageBar: 'Pokrivenost',
    covered: 'pokriveno',
    uncovered: 'nepokriveno',
    filterByStatus: 'Filtriraj po statusu',
    filterByCategory: 'Filtriraj po kategoriji',
    filterByNation: 'Filtriraj po naciji',
    searchRequests: 'Pretrazi zahtjeve...',
    confirmWithdraw: 'Da li ste sigurni da zelite da povucete ovaj zahtjev?',
    confirmDelete: 'Da li ste sigurni da zelite da obrisete ovaj zahtjev?',
    confirmPublish: 'Da li ste sigurni da zelite da objavite ovaj zahtjev? Bice vidljiv svim nacijama.',
    confirmStartSelection: 'Da li ste sigurni da zelite da zapocnete selekciju? Nacije ce moci da daju ponude.',
    warningStartSelection: 'Pokretanje selekcije ce ovaj zahtjev uciniti vidljivim svim nacijama ucesnicama. One ce moci da podnesu ponude za pacijente u ovom zahtjevu. Ova radnja se ne moze ponistiti.',
    warningMakeOffer: 'Podnosenjem ove ponude obavezujete svoju naciju da obezbijedi predlozenu pomoc. Ova radnja ce obavijestiti naciju koja je podnijela zahtjev i kontrolu vjezbe.',
    saveDraft: 'Sacuvaj nacrt',
    saving: 'Cuvanje...',
    saveAndSubmit: 'Sacuvaj i posalji',
    step: 'Korak {{number}}',
    generalInfo: 'Opste informacije',
    patientInfo: 'Informacije o pacijentu',
    logisticsInfo: 'Logisticke informacije',
    reviewSubmit: 'Pregled i slanje',
    requestTitle: 'Naslov zahtjeva',
    requestDescription: 'Opis zahtjeva',
    numberOfPatients: 'Broj pacijenata',
    typeOfAssistance: 'Vrsta pomoci',
    medicalTreatment: 'Medicinsko lijecenje',
    transportAssistance: 'Transportna pomoc',
    both: 'Oboje',
    treatmentOnly: 'Samo lijecenje',
    transportOnly: 'Samo transport',
    validationErrors: 'Molimo ispravite sljedece greske:',
    fieldRequired: 'Ovo polje je obavezno',
    selectExitHub: 'Izaberite izlazno cvoriste',
    createExitHub: 'Kreiraj izlazno cvoriste',
    backToRequests: 'Nazad na zahtjeve',
    noRequestsFound: 'Nijesu pronadjeni zahtjevi',
    createFirstRequest: 'Kreirajte svoj prvi zahtjev da pocnete',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Ponude',
    createOffer: 'Kreiraj ponudu',
    makeOffer: 'Daj ponudu',
    manageOffers: 'Upravljaj ponudama',
    offerDetail: 'Detalji ponude',
    offerId: 'ID ponude',
    offeringNation: 'Nacija koja nudi',
    offerType: 'Tip ponude',
    treatment: 'Lijecenje',
    transport: 'Transport',
    combined: 'Kombinovano',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Ponuda lijecenja',
    transportOffer: 'Ponuda transporta',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Izaberite pacijente',
    selectedPatients: 'Izabrani pacijenti',
    patientSelection: 'Izbor pacijenata',
    offerConfiguration: 'Konfiguracija ponude',
    reviewOffer: 'Pregled ponude',
    submitOffer: 'Posalji ponudu',
    submitting: 'Slanje...',
    acceptOffer: 'Prihvati ponudu',
    rejectOffer: 'Odbij ponudu',
    withdrawOffer: 'Povuci ponudu',
    noOffers: 'Nema dostupnih ponuda',
    noOffer: 'No Offer',
    offerStatus: 'Status ponude',
    offerDate: 'Datum ponude',
    transportAsset: 'Transportno sredstvo',
    departureDate: 'Datum polaska',
    arrivalDate: 'Datum dolaska',
    treatmentFacility: 'Zdravstvena ustanova',
    capacity: 'Kapacitet',
    availableCapacity: 'Dostupni kapacitet',
    totalCapacity: 'Ukupni kapacitet',
    selectAsset: 'Izaberite sredstvo',
    selectFacility: 'Izaberite ustanovu',
    offerNotes: 'Napomene uz ponudu',
    confirmAccept: 'Da li ste sigurni da zelite da prihvatite ovu ponudu?',
    confirmReject: 'Da li ste sigurni da zelite da odbijete ovu ponudu?',
    extendTransport: 'Produzeni transport',
    transportExtension: 'Produzenje transporta',
    comparisonView: 'Uporedni pregled',
    shortlist: 'Uzi izbor',
    addToShortlist: 'Dodaj u uzi izbor',
    removeFromShortlist: 'Ukloni iz uzeg izbora',
    leaveConfirmTitle: 'Napustiti stranicu?',
    leaveConfirmMessage: 'Imate nesacuvane izmjene. Da li ste sigurni da zelite da napustite stranicu?',
    stayOnPage: 'Ostani na stranici',
    leavePage: 'Napusti stranicu',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transporti',
    missionDetail: 'Detalji transporta',
    missionId: 'ID transporta',
    missionStatus: 'Status transporta',
    createMission: 'Kreiraj transport',
    overview: 'Pregled',
    patientsTab: 'Pacijenti',
    transportsTab: 'Dionice transporta',
    treatmentTab: 'Lijecenje',
    reviewTab: 'Pregled',
    departure: 'Polazak',
    arrival: 'Dolazak',
    origin: 'Polaziste',
    destination: 'Odrediste',
    stops: 'Stanice',
    addStop: 'Dodaj stanicu',
    removeStop: 'Ukloni stanicu',
    stopName: 'Naziv stanice',
    stopType: 'Tip stanice',
    estimatedTime: 'Procijenjeno vrijeme',
    actualTime: 'Stvarno vrijeme',
    asset: 'Sredstvo',
    driver: 'Vozac',
    crew: 'Posada',
    noMissions: 'Nijesu pronadjeni transporti',
    completeMission: 'Zavrsi transport',
    cancelMission: 'Otkazi transport',
    startTransport: 'Zapocni transport',
    missionChain: 'Lanac transporta',
    linkedMissions: 'Povezani transporti',
    handover: 'Primopredaja',
    handoverPoint: 'Tacka primopredaje',
    pickupPoint: 'Tacka preuzimanja',
    dropoffPoint: 'Tacka iskrcavanja',
    searchTransports: 'Pretrazi transporte...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Pacijenti',
    myPatients: 'Moji pacijenti',
    patientId: 'ID pacijenta',
    firstName: 'Ime',
    lastName: 'Prezime',
    dateOfBirth: 'Datum rodjenja',
    age: 'Starost',
    gender: 'Pol',
    male: 'Muski',
    female: 'Zenski',
    other: 'Ostalo',
    nationality: 'Drzavljanstvo',
    diagnosis: 'Dijagnoza',
    condition: 'Stanje',
    stable: 'Stabilno',
    critical: 'Kriticno',
    serious: 'Ozbiljno',
    treatmentNeeded: 'Potrebno lijecenje',
    allergies: 'Alergije',
    medications: 'Ljekovi',
    bloodType: 'Krvna grupa',
    weight: 'Tezina (kg)',
    infectious: 'Zarazno',
    mentalHealth: 'Mentalno zdravlje',
    mobility: 'Pokretljivost',
    ambulatory: 'Pokretan',
    wheelchair: 'Invalidska kolica',
    stretcher: 'Nosila',
    intensive: 'Intenzivna njega',
    oxygenRequired: 'Potreban kiseonik',
    ventilator: 'Ventilator',
    medicalEscort: 'Medicinska pratnja',
    noPatients: 'Nijesu pronadjeni pacijenti',
    patientDetails: 'Detalji pacijenta',
    medicalHistory: 'Medicinska istorija',
    travelDocuments: 'Putna dokumenta',
    passport: 'Pasos',
    pseudonymizedId: 'Pseudonimizovani ID',
    sensitiveData: 'Osjetljivi podaci',
    journey: 'Putanja pacijenta',
    assignedTo: 'Dodijeljen',
    currentLocation: 'Trenutna lokacija',
    importPatients: 'Uvezi pacijente',
    exportPatients: 'Izvezi pacijente',
    seated: 'Sjedeci',
    lying: 'Lezeci',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Korisnici',
    createUser: 'Kreiraj korisnika',
    editUser: 'Izmijeni korisnika',
    deleteUser: 'Obrisi korisnika',
    username: 'Korisnicko ime',
    displayName: 'Ime za prikaz',
    email: 'E-posta',
    password: 'Lozinka',
    role: 'Uloga',
    roles: 'Uloge',
    nation: 'Nacija',
    active: 'Aktivan',
    lastLogin: 'Posljednja prijava',
    createdAt: 'Kreirano',
    isNation: 'Nacija',
    isEU: 'EU',
    isAdmin: 'Administrator',
    isExcon: 'EXCON',
    isPlanner: 'Planer',
    isHub: 'Cvoriste',
    isReadOnly: 'Samo za citanje',
    noUsers: 'Nijesu pronadjeni korisnici',
    confirmDelete: 'Da li ste sigurni da zelite da obrisete ovog korisnika?',
    resetPassword: 'Resetuj lozinku',
    generatePassword: 'Generisi lozinku',
    searchUsers: 'Pretrazi korisnike...',
    userCreated: 'Korisnik je uspjesno kreiran',
    userUpdated: 'Korisnik je uspjesno azuriran',
    userDeleted: 'Korisnik je uspjesno obrisan',
    selectNation: 'Izaberite naciju',
    mustChangePassword: 'Mora promijeniti lozinku pri sljedecoj prijavi',
    flagImage: 'Slika zastave',
    exportUsers: 'Izvezi korisnike',
    importUsers: 'Uvezi korisnike',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Sredstva',
    createAsset: 'Kreiraj sredstvo',
    editAsset: 'Izmijeni sredstvo',
    deleteAsset: 'Obrisi sredstvo',
    assetName: 'Naziv sredstva',
    assetType: 'Tip sredstva',
    capacitySeated: 'Kapacitet (sjedeci)',
    capacityLying: 'Kapacitet (lezeci)',
    capacityIntensive: 'Kapacitet (intenzivna njega)',
    owner: 'Vlasnik',
    operator: 'Operater',
    baseLocation: 'Bazna lokacija',
    range: 'Domet',
    speed: 'Brzina',
    noAssets: 'Nijesu pronadjena sredstva',
    confirmDelete: 'Da li ste sigurni da zelite da obrisete ovo sredstvo?',
    searchAssets: 'Pretrazi sredstva...',
    assetCreated: 'Sredstvo je uspjesno kreirano',
    assetUpdated: 'Sredstvo je uspjesno azurirano',
    assetDeleted: 'Sredstvo je uspjesno obrisano',
    exportAssets: 'Izvezi sredstva',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Cvorista',
    startPoints: 'Polazne tacke',
    createHub: 'Kreiraj cvoriste',
    editHub: 'Izmijeni cvoriste',
    deleteHub: 'Obrisi cvoriste',
    hubName: 'Naziv cvorista',
    hubType: 'Tip cvorista',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Ulazno cvoriste',
    airport: 'Aerodrom',
    seaport: 'Luka',
    railStation: 'Zeljeznnicka stanica',
    roadPoint: 'Drumska tacka',
    ucpmClassification: 'UCPM klasifikacija',
    icaoCode: 'ICAO kod',
    iataCode: 'IATA kod',
    noHubs: 'Nijesu pronadjena cvorista',
    confirmDelete: 'Da li ste sigurni da zelite da obrisete ovo cvoriste?',
    searchHubs: 'Pretrazi cvorista...',
    nationAssignment: 'Dodjela nacija',
    assignNations: 'Dodijeli nacije',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Zdravstvene ustanove',
    createFacility: 'Kreiraj ustanovu',
    editFacility: 'Izmijeni ustanovu',
    deleteFacility: 'Obrisi ustanovu',
    facilityName: 'Naziv ustanove',
    facilityType: 'Tip ustanove',
    hospitalName: 'Naziv bolnice',
    bedCapacity: 'Kapacitet kreveta',
    specialties: 'Specijalnosti',
    availableBeds: 'Dostupni kreveti',
    totalBeds: 'Ukupno kreveta',
    contactPerson: 'Kontakt osoba',
    noFacilities: 'Nijesu pronadjene zdravstvene ustanove',
    confirmDelete: 'Da li ste sigurni da zelite da obrisete ovu ustanovu?',
    searchFacilities: 'Pretrazi ustanove...',
    hubNationAssignment: 'Dodjela nacija cvorista',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Rasporedi',
    createSchedule: 'Kreiraj raspored',
    editSchedule: 'Izmijeni raspored',
    deleteSchedule: 'Obrisi raspored',
    scheduleName: 'Naziv rasporeda',
    scheduleType: 'Tip rasporeda',
    recurring: 'Ponavljajuci',
    oneTime: 'Jednokratni',
    frequency: 'Ucestalost',
    daily: 'Dnevno',
    weekly: 'Sedmicno',
    startDate: 'Datum pocetka',
    endDate: 'Datum zavrsetka',
    departureTime: 'Vrijeme polaska',
    arrivalTime: 'Vrijeme dolaska',
    stops: 'Stanice',
    addStop: 'Dodaj stanicu',
    noSchedules: 'Nijesu pronadjeni rasporedi',
    bookings: 'Rezervacije',
    timeline: 'Hronologija',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Obavjestenja',
    markAllRead: 'Oznaci sve kao procitano',
    markAsRead: 'Oznaci kao procitano',
    markAsUnread: 'Oznaci kao neprocitano',
    noNotifications: 'Nema obavjestenja',
    viewAll: 'Prikazi sva obavjestenja',
    settings: 'Podesavanja obavjestenja',
    emailNotifications: 'Obavjestenja putem e-poste',
    inAppNotifications: 'Obavjestenja u aplikaciji',
    notifyOn: 'Obavijesti me o',
    requestCreated: 'Novi zahtjev',
    requestPublished: 'Zahtjev objavljen',
    requestClosed: 'Zahtjev zatvoren',
    requestCompleted: 'Zahtjev zavrsen',
    commentAdded: 'Novi komentar',
    offerReceived: 'Ponuda primljena',
    offerAccepted: 'Ponuda prihvacena',
    statusChanged: 'Status promijenjen',
    selectionStarted: 'Selekcija zapoceta',
    missionCreated: 'Transport kreiran',
    missionStatusUpdated: 'Transport azuriran',
    transportPartnerNamed: 'Transportni partner',
    transportExtensionReceived: 'Produzenje transporta',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Podesavanja',
    general: 'Opsta',
    system: 'Sistem',
    email: 'E-posta',
    sync: 'Sinhronizacija',
    security: 'Bezbjednost',
    appearance: 'Izgled',
    systemName: 'Naziv sistema',
    systemEmail: 'E-posta sistema',
    maintenanceMode: 'Rezim odrzavanja',
    readOnlyMode: 'Rezim samo za citanje',
    emailEnabled: 'E-posta omogucena',
    smtpHost: 'SMTP server',
    smtpPort: 'SMTP port',
    smtpUser: 'SMTP korisnik',
    smtpPassword: 'SMTP lozinka',
    senderEmail: 'E-posta posiljaoca',
    senderName: 'Ime posiljaoca',
    testEmail: 'Posalji test e-postu',
    syncEnabled: 'Sinhronizacija omogucena',
    syncUrl: 'URL sinhronizacije',
    syncApiKey: 'API kljuc sinhronizacije',
    settingsSaved: 'Podesavanja su uspjesno sacuvana',
    helpdesk: 'Podrska',
    helpdeskTitle: 'Naslov podrske',
    helpdeskEmail: 'E-posta podrske',
    helpdeskPhone: 'Telefon podrske',
    helpdeskInfo: 'Informacije o podrsci',
    realLifeSupport: 'Podrska u stvarnom zivotu',
    trainingMode: 'Rezim obuke',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Evidencija revizije',
    action: 'Akcija',
    user: 'Korisnik',
    target: 'Cilj',
    details: 'Detalji',
    timestamp: 'Vremenska oznaka',
    ipAddress: 'IP adresa',
    noLogs: 'Nijesu pronadjeni zapisi revizije',
    searchLogs: 'Pretrazi zapise...',
    filterByAction: 'Filtriraj po akciji',
    filterByUser: 'Filtriraj po korisniku',
    exportLogs: 'Izvezi zapise',
    exportCsv: 'Izvezi CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Kontrola vjezbe',
    currentDay: 'Tekuci dan',
    exerciseDay: 'Dan vjezbe',
    nextDay: 'Sljedeci dan',
    previousDay: 'Prethodni dan',
    resetExercise: 'Resetuj vjezbu',
    startExercise: 'Zapocni vjezbu',
    endExercise: 'Zavrsi vjezbu',
    dayReset: 'Resetovanje dana',
    confirmReset: 'Da li ste sigurni da zelite da resetujete dan vjezbe? Ovo ce obrisati sve podatke za tekuci dan.',
    resetInProgress: 'Resetovanje u toku...',
    maintenanceMode: 'Rezim odrzavanja',
    enableMaintenance: 'Omoguci odrzavanje',
    disableMaintenance: 'Onemogucui odrzavanje',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Sinhronizacija podataka',
    syncStatus: 'Status sinhronizacije',
    lastSync: 'Posljednja sinhronizacija',
    pendingItems: 'Stavke na cekanju',
    syncNow: 'Sinhronizuj sada',
    syncing: 'Sinhronizacija...',
    syncSuccess: 'Sinhronizacija uspjesno zavrsena',
    syncFailed: 'Sinhronizacija nije uspjela',
    outbox: 'Izlazno sanduce',
    inbox: 'Dolazno sanduce',
    configuration: 'Konfiguracija',
    targetUrl: 'Odredisni URL',
    apiKey: 'API kljuc',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Mapa',
    layers: 'Slojevi',
    requests: 'Zahtjevi',
    hubs: 'Cvorista',
    facilities: 'Ustanove',
    routes: 'Rute',
    showAll: 'Prikazi sve',
    hideAll: 'Sakrij sve',
    zoomIn: 'Uvecaj',
    zoomOut: 'Umanji',
    resetView: 'Resetuj prikaz',
    satellite: 'Satelitski',
    terrain: 'Teren',
    offline: 'Van mreze',
    online: 'Na mrezi',
    tilesOffline: 'Kartografske plocice se ucitavaju lokalno',
    tilesOnline: 'Kartografske plocice se ucitavaju sa online servera',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistika',
    overview: 'Pregled',
    requestsByStatus: 'Zahtjevi po statusu',
    requestsByCategory: 'Zahtjevi po kategoriji',
    requestsByNation: 'Zahtjevi po naciji',
    offersByStatus: 'Ponude po statusu',
    patientsByCondition: 'Pacijenti po stanju',
    transportsByStatus: 'Transporti po statusu',
    timeline: 'Hronologija',
    totalRequests: 'Ukupno zahtjeva',
    totalOffers: 'Ukupno ponuda',
    totalPatients: 'Ukupno pacijenata',
    totalTransports: 'Ukupno transporta',
    averageResponseTime: 'Prosjecno vrijeme odgovora',
    completionRate: 'Stopa zavrsenosti',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Statistika vjezbe',
    overview: 'Pregled',
    byCategory: 'Po kategoriji',
    byNation: 'Po naciji',
    byDay: 'Po danu',
    totalPatientsMoved: 'Ukupno premjestenih pacijenata',
    totalRequestsProcessed: 'Ukupno obradjenih zahtjeva',
    averageProcessingTime: 'Prosjecno vrijeme obrade',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Dijagram toka',
    sankey: 'Sanki',
    nodeGraph: 'Graf cvorova',
    refresh: 'Osvjezi',
    noData: 'Nema podataka o toku',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'O sistemu',
    version: 'Verzija',
    systemInfo: 'Sistemske informacije',
    buildDate: 'Datum izgradnje',
    environment: 'Okruzenje',
    description: 'ARCOS — Napredni sistem za komunikaciju zahtjeva',
    subtitle: 'Pomoc zrtvama i medicinske operacije',
    whatIsArcos: 'Шта је ARCOS? – Објашњење за учеснике вежбе',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'Подржано од MMCC-E',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – где радозналост среће сарадњу.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentacija',
    gettingStarted: 'Pocetni koraci',
    userGuide: 'Korisnicko uputstvo',
    faq: 'Cesta pitanja',
    troubleshooting: 'Resavanje problema',
    apiReference: 'API referenca',
    downloadTemplate: 'Preuzmi sablon',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Uvoz pacijenata',
    uploadFile: 'Otpremi fajl',
    selectFile: 'Izaberi fajl',
    preview: 'Pregled',
    importNow: 'Uvezi sada',
    importing: 'Uvoz u toku...',
    importSuccess: '{{count}} pacijenata uspjesno uvezeno',
    importFailed: 'Uvoz nije uspio',
    downloadTemplate: 'Preuzmi sablon',
    dragDrop: 'Prevucite i otpustite fajl ovdje, ili kliknite da izaberete',
    supportedFormats: 'Podrzani formati: XLSX, XLS, CSV',
    rowsFound: '{{count}} redova pronadjeno',
    validRows: '{{count}} validnih redova',
    invalidRows: '{{count}} nevalidnih redova',
    duplicateRows: '{{count}} dupliranih redova',
    previewData: 'Pregled podataka',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Planiranje transporta',
    planRoute: 'Planiraj rutu',
    routeBuilder: 'Kreator rute',
    addWaypoint: 'Dodaj tacku puta',
    removeWaypoint: 'Ukloni tacku puta',
    estimatedDuration: 'Procijenjeno trajanje',
    distance: 'Rastojanje',
    selectVehicle: 'Izaberite vozilo',
  },

  transportBooking: {
    title: 'Rezervacija transporta',
    bookTransport: 'Rezervisi transport',
    availableSlots: 'Dostupni termini',
    bookingConfirmed: 'Rezervacija potvrdjena',
    cancelBooking: 'Otkazi rezervaciju',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Planiranje kapaciteta',
    totalCapacity: 'Ukupni kapacitet',
    usedCapacity: 'Iskorisceni kapacitet',
    availableCapacity: 'Dostupni kapacitet',
    utilizationRate: 'Stopa iskoriscenosti',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Sabloni sredstava',
    dayTemplates: 'Dnevni sabloni',
    createTemplate: 'Kreiraj sablon',
    editTemplate: 'Izmijeni sablon',
    deleteTemplate: 'Obrisi sablon',
    templateName: 'Naziv sablona',
    applyTemplate: 'Primijeni sablon',
    noTemplates: 'Nijesu pronadjeni sabloni',
    confirmDelete: 'Da li ste sigurni da zelite da obrisete ovaj sablon?',
    confirmApply: 'Da li ste sigurni da zelite da primijenite ovaj sablon? Ovo ce prepisati postojece podatke.',
    exportTemplates: 'Izvezi sablone',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Traka obavjestenja',
    createAnnouncement: 'Kreiraj obavjestenje',
    editAnnouncement: 'Izmijeni obavjestenje',
    deleteAnnouncement: 'Obrisi obavjestenje',
    message: 'Poruka',
    startTime: 'Vrijeme pocetka',
    endTime: 'Vrijeme zavrsetka',
    active: 'Aktivno',
    noAnnouncements: 'Nema obavjestenja',
    confirmDelete: 'Da li ste sigurni da zelite da obrisete ovo obavjestenje?',
  },

  // ============================================================
  // COMPONENTS — Stringovi za komponente za visekratnu upotrebu
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Pretrazi...',
      noResults: 'Nema rezultata',
      showing: 'Prikazano {{from}} do {{to}} od {{total}}',
      rowsPerPage: 'Redova po stranici',
      previousPage: 'Prethodna stranica',
      nextPage: 'Sljedeca stranica',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Potvrdi',
      cancel: 'Otkazi',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Nesacuvane izmjene',
      message: 'Imate nesacuvane izmjene. Da li ste sigurni da zelite da napustite ovu stranicu?',
      stay: 'Ostani na stranici',
      leave: 'Napusti stranicu',
    },
    // EmptyState
    emptyState: {
      noData: 'Nema dostupnih podataka',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Doslo je do greske',
      message: 'Doslo je do neocekivane greske. Molimo pokusajte da osvjezite stranicu.',
      retry: 'Pokusaj ponovo',
    },
    // ExportButton
    exportButton: {
      export: 'Izvezi',
      exporting: 'Izvoz u toku...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Stampaj',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Nacrt',
      review: 'Pregled',
      published: 'Objavljeno',
      selection: 'Selekcija',
      inTransit: 'U tranzitu',
      completed: 'Zavrseno',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Online instanca',
      message: 'Rezim samo za citanje. Podaci se sinhronizuju sa primarnog servera.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Gledate kao',
      loggedInAs: 'prijavljeni kao {{nation}}',
      returnTo: 'Povratak na {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Pretrazi stranice, zahtjeve, transporte...',
      searching: 'Pretrazivanje...',
      noResults: 'Nema rezultata za "{{query}}"',
      navigate: 'Navigacija',
      select: 'Izaberi',
      close: 'Zatvori',
      pages: {
        dashboard: 'Kontrolna tabla',
        requests: 'Zahtjevi',
        transports: 'Transporti',
        map: 'Mapa',
        myPatients: 'Moji pacijenti',
        flowDiagram: 'Dijagram toka',
        statistics: 'Statistika',
        assets: 'Sredstva',
        startPoints: 'Polazne tacke / Cvorista',
        treatmentFacilities: 'Zdravstvene ustanove',
        users: 'Korisnici',
        settings: 'Podesavanja',
        auditLogs: 'Evidencija revizije',
        exerciseControl: 'Kontrola vjezbe',
        dataSync: 'Sinhronizacija podataka',
        patientImport: 'Uvoz pacijenata',
        notifications: 'Obavjestenja',
        documentation: 'Dokumentacija',
      },
      actions: {
        importPatientsJson: 'Увези Пацијенте (JSON)',
        importPatientsExcel: 'Увези Пацијенте (Excel)',
        importUsers: 'Увези Кориснике (Excel)',
        importAssetTemplates: 'Увези Шаблоне средстава (Excel)',
        importDayTemplates: 'Увези Уносе дневног шаблона (Excel)',
        exportRequests: 'Извези Захтеве (Excel)',
        exportPatients: 'Извези Пацијенте (Excel)',
        exportUsers: 'Извези Кориснике (Excel)',
        exportCredentials: 'Извези Акредитиве (PDF)',
        exportAuditExcel: 'Извези Ревизорски дневник (Excel)',
        exportAuditPdf: 'Извези Ревизорски дневник (PDF)',
        pagePatientImport: 'Страница увоза пацијената',
        pageRequestDetail: 'Страница детаља захтева',
        pageUsers: 'Страница управљања корисницима',
        pageAssetTemplates: 'Страница шаблона средстава',
        pageDayTemplates: 'Страница дневних шаблона',
        pageRequests: 'Страница листе захтева',
        pageAuditLogs: 'Страница ревизорског дневника',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Sesija istice',
      message: 'Vasa sesija ce isteci za <strong>{{time}}</strong>. Molimo sacuvajte svoj rad i ponovo se prijavite da nastavite.',
      dismiss: 'Odbaci',
      logoutNow: 'Odjavi se sada',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Izaberite 4 vremenske zone',
      configure: 'Konfigurisite vremenske zone',
      reset: 'Resetuj',
      apply: 'Primijeni',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Izaberite lokaciju',
      latitude: 'Geografska sirina',
      longitude: 'Geografska duzina',
      clickToSelect: 'Kliknite na mapu da izaberete lokaciju',
    },
    // Modal
    modal: {
      close: 'Zatvori',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Pocetna',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Odrzavanje sistema',
    message: 'Sistem se resetuje za sljedeci dan vjezbe. Molimo sacekajte dok se proces ne zavrsi.',
    autoRefresh: 'Ova stranica ce se automatski osvjeziti kada sistem ponovo bude dostupan.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Најмање 10 знакова',
    uppercase: '1 велико слово',
    lowercase: '1 мало слово',
    digit: '1 цифра',
    special: '1 специјалан знак',
  },
};

export default sr;
